  <div class="h-full flex flex-col items-center justify-start text-center bg-light-gray pt-[60px]">
    <div class="container flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <img src="svg/pulgar.svg" class="logo-felicitaciones" alt="Logo Felicitaciones" />     
          <h1 class="my-4 text-dark-blue font-bold text-2xl">¡Felicitaciones!</h1>          
      </div>
      <div class="row">
        <div class="col d-flex justify-content-center ">
            <p class="text-xs font-thin m-[10px]">Diste el primer paso hacia el cumplimiento de tus propósitos. En el Portal Transaccional podrás consultar el saldo y fecha de corte de tu ahorro, lo encontrarás como <b class="text-dark-blue font-bold">{{pap?.savingsCategory?.productName}}</b>.</p>
        </div>
      </div>
      <div class="row p-3 w-full ">
        <div class="content ml-5">
            <p class="text-left text-xs m-0">Cuota: <b class="text-dark-blue">${{ formatQuota(pap?.quota ?? '') }}</b></p>
            <p class="text-left text-xs m-0">Duración: <b class="text-dark-blue">{{ pap?.duration }} Meses</b></p>
            <p class="text-left text-xs m-0">Motivo: <b class="text-dark-blue">{{ pap?.target?.name }}</b></p>
            <p class="text-left text-xs m-0">Método de pago: <b class="text-dark-blue">Descuento nómina</b></p>
        </div>
            <button type="button" (click)="finish()" class="btn-primary mt-6">
              Finalizar
            </button>
      </div>
    </div>
  </div>
  